import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { BigExclamation } from "components/icons/BigExclamation";
import { useToast } from "hooks/useToast";
import { useCancelBroadcastCallMutation } from "store/apis/broadcastCall";
import { BackendError } from "types/utils/error";
import { ModalProps } from "types/utils/modal";

export const CancelScheduleBroadcastCall = ({
  broadcastCallId,
  close,
  isOpen,
}: ModalProps & {
  broadcastCallId: string;
}) => {
  const { alertToast, successToast } = useToast();
  const [cancelBroadcast, { isLoading }] = useCancelBroadcastCallMutation();

  const cancelBroadcastCall = async () => {
    try {
      await cancelBroadcast({ campaign_uuid: broadcastCallId }).unwrap();
      successToast({
        title: "Cancelled successfully",
        message: "Broadcast cancelled",
      });
      close();
    } catch (e) {
      alertToast({ message: (e as BackendError)?.data?.error?.message });
    }
  };

  return (
    <>
      <Modal.Root open={isOpen} onOpenChange={close}>
        <Modal.Content size="small">
          <Modal.Header className="!t-border-0 !t-pb-0">
            <Modal.Title>
              <BigExclamation />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="t-space-y-2">
            <div className="t-text-subtext t-text-text-black">
              Cancel Scheduled Broadcast?
            </div>
            <div className="t-text-body-sm t-text-text-30">
              This will cancel the scheduled call. Are you sure?
            </div>
          </Modal.Body>
          <Modal.FooterButtonGroup>
            <Modal.RawClose asChild>
              <Button>Go Back</Button>
            </Modal.RawClose>
            <Button
              disabled={isLoading}
              customType="danger"
              isLoading={isLoading}
              onClick={cancelBroadcastCall}
            >
              Cancel Broadcast
            </Button>
          </Modal.FooterButtonGroup>
        </Modal.Content>
      </Modal.Root>
    </>
  );
};
